
import React from 'react';

const Header: React.FC = () => {
    return (
        <header className="bg-white shadow-md w-full p-4">
            <div className="container mx-auto flex flex-col justify-center items-center text-center">
                <img 
                    alt="Company Logo" 
                    className="w-120 h-auto mb-2 p-4 md:px-0"
                    src="/images/impulse_1000.png"
                />
                <p className="text-lg font-semibold text-gray-700">Herzlich Willkommen zur ersten Registrierung zur Limbach Jahresauftaktveranstaltung 2026!</p>
                <p className="text-gray-600 mt-2">Bitte füllen Sie dieses Formular bis zum 26.09.2025 aus.</p>
            </div>
        </header>
    );
};

export default Header;
